<button class="my-dropdown-item" (click)="openModal(content)" ngbDropdownItem>Deletar</button>

<ng-template
  #content
  let-c="close"
  let-close="dismiss"
  class="modal-Politicas-deletar">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Deletar</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h5>
      Tem certeza que deseja excluir
      <strong>{{ dado }}</strong
      >?
    </h5>
    <h5>Você não poderá desfazer essa ação.</h5>
  </div>
  <div class="modal-footer">
    <a class="btn btn-primary" (click)="deleteRequest.emit($event); close(true)">Excluir</a>
    <a class="btn btn-cancelar" (click)="close()">Cancelar</a>
  </div>
</ng-template>
